// Single source of truth for contact details. Swap the email here when the
// business address is ready (e.g. hello@quantumcover.co.nz).
export const CONTACT = {
  phone: "022 049 4225",
  phoneHref: "tel:+64220494225",
  email: "hello@quantumcover.co.nz",
  get emailHref() { return `mailto:${this.email}`; },
  location: "Auckland, New Zealand",
  linkedin: "Quantum Cover",
  linkedinUrl: "https://www.linkedin.com/company/quantum-cover",
  hoursDays: "Monday – Sunday",
  hoursTime: "9:00 am – 7:00 pm NZST",
  website: "quantumcover.co.nz",
  websiteUrl: "https://quantumcover.co.nz",
};

// Single source of truth for booking availability. Change these to update the
// booking calendar everywhere (keep in step with CONTACT.hoursDays/hoursTime).
export const AVAILABILITY = {
  timezone: "Pacific/Auckland",
  startHour: 9,        // first bookable slot (24h)
  endHour: 19,         // last bookable slot (24h) — 19 = 7:00 pm
  slotIntervalHours: 1,
  daysToShow: 8,       // how many upcoming days to offer
  includeWeekends: true,
};
